import axios from "axios";
import moment from "moment";

export const getCapacityPlaningCollaboratorKPI = (
  organizationId,
  collaboratorId,
  date,
  erpId
) => {
  const requestUrl = `/team/capacity/collaborator/kpi`;
  let params = {
    organization: organizationId,
    erpId: erpId,
    collaborator: collaboratorId,
    date: date ? date.format("Y-MM-DDTH:mm:ss") : date
  };

  return axios.get(requestUrl, { params });
};
export const getCapacityPlaningCollaboratorClient = (
  organizationId,
  collaboratorId,
  collaboratorErpId,
  analysisPlan,
  role,
  qp,
  date,
  isAnnual,
  clientName
) => {
  const requestUrl = `/team/capacity/collaborator/client`;
  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      collaborator: collaboratorId,
      collaboratorErpId: collaboratorErpId,
      role: role,
      qp: qp,
      analysisPlan: analysisPlan,
      date: date
        ? date.format("Y-MM-DDTH:mm:ss")
        : moment().format("YYYY-MM-DD hh:mm:ss"),
      isAnnual: isAnnual,
      clientName: clientName
    }
  });
};

export const getCapacityPlaningProduction = (
  organizationId,
  analyseDate,
  searchWord,
  collaboratorState,
  deletedStatus
) => {
  const requestUrl = `/team/capacity/production`;
  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      date: analyseDate ? analyseDate : moment().format("YYYY-MM-DD hh:mm:ss"),
      searchWord: searchWord,
      collaboratorState: JSON.stringify(collaboratorState),
      deletedStatus
    }
  });
};

export const getCollaboratorFinancial = (
  organizationId,
  collaboratorId,
  role,
  attribution,
  date,
  sortBy,
  clientCRMGroup,
  clientCRMTypes,
  deletedStatus,
  searchWord
) => {
  const requestUrl = `/team/collaborator/financial`;
  return axios.get(requestUrl, {
    params: {
      organization: organizationId,
      collaborator: collaboratorId,
      sortBy: sortBy,
      role: role,
      attribution: attribution,
      date: date
        ? date.format("Y-MM-DDTH:mm:ss")
        : moment().format("YYYY-MM-DD hh:mm:ss"),
      clientCRMGroup: JSON.stringify(clientCRMGroup),
      clientCRMTypes: JSON.stringify(clientCRMTypes),
      deletedStatus: deletedStatus,
      searchWord: searchWord
    }
  });
};

export const getGroupedCapacityPlaningClients = (
  organizationId,
  period,
  searchWord,
  collaborator,
  clientTypes,
  clientCRMTypes,
  clientCRMGroup,
  clients,
  collaboratorRole,
  collaboratorBudgetSortBy,
  VATPeriodicity,
  closingDate,
  deletedStatus
) => {
  const requestUrl = `/team/collaborator-clients-budget`;
  return axios.get(requestUrl, {
    params: {
      organizationId,
      period,
      searchWord,
      collaborator,
      clientTypes,
      clientCRMTypes,
      clientGroups: clientCRMGroup,
      clients: clients.map(({ value }) => value),
      collaboratorRole,
      collaboratorBudgetSortBy,
      vatPeriodicity: VATPeriodicity,
      closingDate,
      deletedStatus
    }
  });
};

export const exportCapacityDossier = (
  organizationId,
  period,
  searchWord,
  collaborator,
  clientTypes,
  clientCRMTypes,
  clientCRMGroup,
  clients,
  collaboratorRole,
  collaboratorBudgetSortBy,
  VATPeriodicity,
  closingDate,
  deletedStatus,
  collaboratorName
) => {
  const requestUrl = `/team/collaborator-clients-budget/export`;

  let params = {
    organizationId,
    period,
    searchWord,
    collaborator,
    clientTypes,
    clientCRMTypes,
    clientGroups: clientCRMGroup,
    clients: clients.map(({ value }) => value),
    collaboratorRole,
    collaboratorBudgetSortBy,
    vatPeriodicity: VATPeriodicity,
    closingDate,
    deletedStatus
  };

  return axios
    .get(requestUrl, {
      params,
      responseType: "blob",
      headers: { Accept: "application/vnd.ms-excel" }
    })
    .then(response => {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.data.type })
      );
      const link = document.createElement("a");
      link.href = url;
      let date = new Date();
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let dateString =
        day +
        "-" +
        month +
        "-" +
        date.getFullYear() +
        " " +
        date.getHours() +
        "-" +
        minutes +
        "-" +
        seconds;
      link.setAttribute(
        "download",
        "PowerTeam " +
          collaboratorName +
          " Capacity-Dossier " +
          dateString +
          ".xlsx"
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};



// WEBPACK FOOTER //
// ./src/api/capacity.js